import { render, staticRenderFns } from "./TierBadge.vue?vue&type=template&id=69473887&scoped=true&"
import script from "./TierBadge.vue?vue&type=script&lang=js&"
export * from "./TierBadge.vue?vue&type=script&lang=js&"
import style0 from "./TierBadge.vue?vue&type=style&index=0&id=69473887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69473887",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69473887')) {
      api.createRecord('69473887', component.options)
    } else {
      api.reload('69473887', component.options)
    }
    module.hot.accept("./TierBadge.vue?vue&type=template&id=69473887&scoped=true&", function () {
      api.rerender('69473887', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/TierBadge.vue"
export default component.exports